module.exports = __webpack_public_path__ + "static/img/ranking-utilize.028eab0f.png";